import React from 'react';
import { Box } from '@mui/material';

import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import ClientsSection from '../components/ClientsSection';
import ContactSection from '../components/ContactSection';

const HomePage: React.FC = () => {
  return (
    <Box sx={{ flex: 1 }}>
      <HeroSection />
      <FeaturesSection />
      <AboutSection />
      <ServicesSection />
      <ClientsSection />
      <ContactSection />
    </Box>
  );
};

export default HomePage;